import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, Kamitaku } from "@/mixins/index";
import { deleteTaskDesc, getTaskDescDesc } from "@/api/kamitaku/kamitaku";
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "kamitakauUpload",
  components: {
    uploadImagetow: uploadImagetow
  },
  mixins: [serchSelect, tabulation, Kamitaku],
  data: function data() {
    return {
      data_type: '',
      ids: [],
      searchData: {},
      paramsData: {
        is_full: 2
      }
    };
  },
  created: function created() {},
  methods: {
    search: function search() {
      this.ids = [];
      this.getTask();
    },
    getTask: function getTask() {
      var _this = this;

      this.reqLoading = true;
      var data = {
        game_id: this.rawData.game_id,
        data_type: this.searchData.data_type
      };
      getTaskDescDesc(data).then(function (res) {
        if (res.code == 200) {
          _this.currentPage = 1;
          _this.PrimitiveData = res.data;
          _this.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
          _this.tableData = _this.currentChangePage(_this.pageSize, _this.currentPage);
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      this.paramsData.is_full = 1;
      var columns = [{
        label: this.$t('game'),
        prop: 'game'
      }, {
        label: this.$t('type'),
        prop: 'data_type'
      }, {
        label: this.$t('taskIdentifier'),
        prop: 'task'
      }, {
        label: this.$t('description'),
        prop: 'desc'
      }];

      var data = _toConsumableArray(this.tableCopyTableList);

      this.$export.csv({
        columns: columns,
        data: data,
        noHeader: true,
        title: this.$route.meta.title
      });
      this.$alert(this.$t('exportModifyTip'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm')
      });
    },
    deleHandle: function deleHandle(dataList) {
      var _this2 = this;

      var ids = dataList.map(function (item) {
        return item.id;
      });
      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleteTaskDesc({
                  ids: ids
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.getTask();

                    _this2.$message({
                      type: "success",
                      message: _this2.$t('operationSuccess')
                    });

                    _this2.ids = [];
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};